<table mat-table [dataSource]="dataSource" class="border border-2 border border-secondary rounded bg-transparent">

  <ng-container matColumnDef="#">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> # </th>
    <td class="fs-7" mat-cell *matCellDef="let element; let i=index;"> {{ i + 1 }} </td>
  </ng-container>

  <ng-container matColumnDef="approvedProducts">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> Approved Products </th>
    <td class="fs-7" mat-cell *matCellDef="let element"> {{element.approvedProducts}} </td>
  </ng-container>

  <ng-container matColumnDef="stateId">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> Approved States </th>
    <td class="fs-7" mat-cell *matCellDef="let element"> {{element.stateId}} </td>
  </ng-container>

  <ng-container matColumnDef="personalLicenseHeld">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> Personal SL License Held </th>
    <td class="fs-7" mat-cell *matCellDef="let element"> {{element.personalLicenseHeld}} </td>
  </ng-container>

  <ng-container matColumnDef="slLicenseNumber">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> State SL License #</th>
    <td class="fs-7" mat-cell *matCellDef="let element"> {{element.slLicenseNumber}} </td>
  </ng-container>

  <ng-container matColumnDef="slLicenseExpiryDate">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> State SL License Expiry </th>
    <td class="fs-7" mat-cell *matCellDef="let element"> {{element.slLicenseExpiryDate | date:'MM-dd-yyyy'}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> </th>
    <td class="fs-7" mat-cell *matCellDef="let element"> 
      <button (click)="onRemoveApprovedProduct(element?.approvedId)" mat-button type="button" class="btn"><i class="bi bi-x fs-3 fw-bold border border-1 border-dark-subtle p-2 rounded"></i></button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

  <!-- Conditional "No records found" Message -->
  @if (dataSource.data.length === 0) {
    <div class="text-center my-2">
      No records found
    </div>
  }
